import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { composeDatasetReducers } from '@libs/datasets';

// Reducers
import auth from 'auth/redux.reducer.js';
import navigation from 'navigation/redux.reducer';
import utilities from 'utilities/redux.reducer';
import dashboard from 'dashboard/redux.reducer';
import common from 'common/redux.reducer';
import employee from 'employee/redux.reducer';
import roles from 'roles/redux.reducer';
import user from 'user/redux.reducer';
import timeAndAttendance from 'timeAndAttendance/redux.reducer';
import leaveCategory from 'leaveCategory/redux.reducer';
import leaveManagement from 'leaveManagement/redux.reducer';
import employeeLeaveManagement from 'leaveAndHolidays/redux.reducer';
import employeeLeaveManagementForUser from 'common/components/leaveDetails/redux.reducer';
import holiday from 'holidays/redux.reducer';
import managerialTree from 'managerialTree/redux.reducer';
import kpiGoal from 'kpi/goal/redux.reducer';
import { kpiTemplateReducer } from 'kpi/template';
import { kpiPeriodReducer } from 'kpi/period';
import userKpiReducer from 'kpi/userKpi/redux.reducer';
import kpiDashboardReducer from 'kpi/dashboard/redux.reducer';
import menu from 'menu/redux.reducer';
import permissions from 'permissions/redux.reducer';
import clientManagement from 'clientManagement/redux.reducer';
import teamManagement from 'teamManagement/redux.reducer';
import profileChangeRequests from 'profileChangeRequests/redux.reducer';
import activityLog from 'activityLog/redux.reducer';

export default combineReducers(
        composeDatasetReducers({
                auth,
                form: formReducer,
                utilities,
                navigation,
                dashboard,
                employee,
                common,
                user,
                roles,
                timeAndAttendance,
                leaveCategory,
                leaveManagement,
                employeeLeaveManagement,
                employeeLeaveManagementForUser,
                holiday,
                managerialTree,
                kpiGoal,
                kpiTemplate: kpiTemplateReducer,
                kpiPeriod: kpiPeriodReducer,
                userKpi: userKpiReducer,
                kpiDashboard: kpiDashboardReducer,
                menu,
                permissions,
                clientManagement,
                teamManagement,
                profileChangeRequests,
                activityLog
        })
);
